import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

import { DffGroupedContent } from "@dffedb/util";
import { InstallationMaalerAflaesningKvitteringService } from "@e-forsyning/common/maaler";

import { FeatureMaalerAflaesningFormBuilder } from "../shared/feature-maaler-aflaesning.form-builder";

@Component({
    selector: "maaler-aflaesning-kvittering",
    templateUrl: "./maaler-aflaesning-kvittering.component.html"
})
export class MaalerAflaesningKvitteringComponent implements OnInit {
    @Input() public formGroup: UntypedFormGroup;

    public kvittering$: Observable<DffGroupedContent>;

    constructor(private readonly kvitteringService: InstallationMaalerAflaesningKvitteringService) {}

    public ngOnInit(): void {
        const { maalerAflaesning } = FeatureMaalerAflaesningFormBuilder.formGroupToMaalerAflaesning(this.formGroup);
        this.kvittering$ = this.kvitteringService.genererKvittering(maalerAflaesning).pipe(shareReplay(1));
    }
}
